import { Box, Card, Container, Typography } from '@mui/material'
import React from 'react'

export default function AboutUs() {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 720 ? true : false)

    //choose the screen size 
    const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }

    return (
        <React.Fragment>
            <Container fluid>
                <Typography variant={isMobile ? 'h5' : 'h4'} >
                    About Us
                </Typography>
                <Container sx={{ width: 80, height: 2, backgroundColor: "black" }} />
                <br />
                <Typography variant='body1' component='h6' justifyContent={"center"} alignItems={"center"} alignContent={"center"} textAlign={"justify"}>
                    The HPC Nexus Laboratory is a dedicated center for High Performance Computing (HPC) research, officially established at the School of Informatics and Cybersecurity, TU Dublin in October 2023. Dr Tania Malik is the founding Director of the HPC Nexus Laboratory. The lab hosts a community of enthusiastic graduate students and affiliated academic and Industry officials dedicated to advancing HPC research and technology.
                </Typography>
            </Container>
        </React.Fragment>
    )
}